import { Component, input, output } from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'app-ui-budget-banner',
  standalone: true,
  templateUrl: './budget-banner.component.html',
  styleUrls: ['./budget-banner.component.scss'],
})
export class BudgetBannerComponent {
  openModal = output<boolean>();
  hasOnRequest = input<boolean>(false);
}
